var map = {
	"./domains/global-settings.json": "vw+c",
	"./webhosting/global-settings.json": "CsC7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Q7Ic";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data ^\.\/.*\/global\-settings\.json$
// module id = Q7Ic
// module chunks = 0